import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSetupDue } from '../../hooks/useSetupDue';

/**
 * Opens the setup checklist for a new owner, once a launch, as the old
 * shell's Home sent them to its onboarding: an owner whose company has no
 * other driver and no call, until they finish or skip it on this device.
 */
export function SetupWatcher() {
  const due = useSetupDue();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const sent = React.useRef(false);
  React.useEffect(() => {
    if (!due || sent.current || pathname === '/onboarding') return;
    sent.current = true;
    navigate('/onboarding');
  }, [due, pathname, navigate]);
  return null;
}
